// extracted by mini-css-extract-plugin
export default {"inputs":"Input_inputs__p+FHe","submit":"Input_submit__D3vQq"};